import MSEAdapter from "./mse_adapter";

const CODECS = {
  h264: 'video/mp4; codecs="avc1.42001E, mp4a.40.2"',
  webmvp8: 'video/webm; codecs="vp8.0, vorbis"',
  mseh264: 'video/mp4; codecs="avc1.4d401e"',
  msewebmvp9: 'video/webm; codecs="vp9"'
};

// encoding detector adapted from http://youtube.com/html5
export default class VideoAdapter {
  static codecs(){
    return CODECS;
  }

  static global(){
    if(typeof this._videoEl == "undefined"){
      this._videoEl = document.createElement("video");
      if(this._videoEl && (typeof this._videoEl.canPlayType == "function")){
        this._videoEl.supported = true;
      }else{
        this._videoEl = this.nullObject();
      }
    }
    return this._videoEl;
  }

  static nullObject(){
    return {
      canPlayType: this.noop
    };
  }

  static noop(){}

  static isSupported(){
    return !!(this.global().supported);
  }

  static canPlayType(codec){
    return this.global().canPlayType(codec);
  }

  static isSupportH264Encoding(){
    return !!(this.canPlayType(this.codecs().h264));
  }

  static isSupportWebmVP8Encoding(){
    return !!(this.canPlayType(this.codecs().webmvp8));
  }

  static checkSupportMSEEncoding(codec){
    var isTypeSupportedFn;

    // isTypeSupported only use to make sure the SourceBuffer API available for user agent with given codec
    if(MSEAdapter.isSupported()){
      isTypeSupportedFn = MSEAdapter.isTypeSupported();
      if(typeof isTypeSupportedFn == "function"){
        return isTypeSupportedFn(codec);
      }else{
        return this.canPlayType(codec);
      }
    }
  }

  static isSupportMSEVP9Encoding(){
    return !!( this.checkSupportMSEEncoding(this.codecs().msewebmvp9) );
  }

  static isSupportMSEH264Encoding(){
    return !!( this.checkSupportMSEEncoding(this.codecs().mseh264) );
  }
}

